var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('em',{staticClass:"bg",class:{
      hasFooterBg:
        _vm.isFooter && (!_vm.isHorizontal || (_vm.isHorizontal && _vm.widthSize == 'normal'))
    },style:(_vm.decorateBg)}),_c('transition',{attrs:{"name":"fade"}},[(_vm.smallBg)?_c('em',{directives:[{name:"show",rawName:"v-show",value:(!_vm.bgState),expression:"!bgState"}],staticClass:"bg",class:{ hasFooterBg: _vm.isFooter },style:(_vm.smallBg)}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }